import AddIcon from "../../../assets/Images/AddIcon.svg";

function AddMoreMagnetButton({
  text,
  onclick,
  additionalClasses,
}: {
  text: string;
  onclick: any;
  additionalClasses?: string;
}) {
  return (
    <div
      className={`flex min-h-[500px]  items-center justify-center rounded-ll border text-center text-white ${additionalClasses}`}
    >
      <button type="button" className="mx-auto flex h-full flex-row items-center  justify-center " onClick={onclick}>
        <div className="flex flex-col">
          <div className=" flex justify-center">
            <img className="h-10 w-10" src={AddIcon} alt="add_button" />
          </div>
          <p className="text-center text-white">{text}</p>
        </div>
      </button>
    </div>
  );
}
export default AddMoreMagnetButton;
